type Props = { props: Record<string, string | number | boolean> }

export function TimerPreview({ props: p }: Props) {
  return (
    <div className="text-center py-3 px-4 rounded-lg bg-tf-warning-lighter">
      <p className="text-sm text-tf-text-sub mb-1">{p.message as string}</p>
      <div className="flex items-center justify-center gap-1 font-mono text-2xl font-bold text-tf-text">
        <span className="bg-tf-bg-card px-2 py-1 rounded">{String(p.minutes).padStart(2, '0')}</span>
        <span>:</span>
        <span className="bg-tf-bg-card px-2 py-1 rounded">00</span>
      </div>
    </div>
  )
}
